import React, { FC, useCallback, useEffect } from "react";
import { GuardianProps } from "..";
import { GuardianFormField, GuardianFormFieldType } from "../../../models/api-models/guardians/guardian-form";
import { GeneralInfo } from "./GeneralInfo";
import { FormField } from "./FormField";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const GuardianFormList: FC<GuardianProps> = ({
    form, formSubmission, isCurrentGuardianSinged, isOtherGuardiansSigned, currentGuardianIsActive
}) => {

    const getValue = useCallback((field: GuardianFormField) => {
        if (!formSubmission || !formSubmission.formData) {
            return ''
        }
        const fieldSubmissionValue = formSubmission.formData.find(d => d.fieldId === field.id);
        if (!fieldSubmissionValue) {
            return ''
        }
        switch(field.valueType) {
            case GuardianFormFieldType.Number:
                return fieldSubmissionValue.decimalValue
            case GuardianFormFieldType.ShortString:
            case GuardianFormFieldType.LongString:
            case GuardianFormFieldType.Dropdown:
            case GuardianFormFieldType.Signature:
            case GuardianFormFieldType.File:
                return typeof fieldSubmissionValue.stringValue !== 'undefined' && fieldSubmissionValue.stringValue
            case GuardianFormFieldType.DateTimeOffset:
                return typeof fieldSubmissionValue.dateTimeOffsetValue === 'string' && 
                    fieldSubmissionValue.dateTimeOffsetValue;
            case GuardianFormFieldType.Bool:
                return typeof fieldSubmissionValue.boolValue === 'boolean' && booleanParser(fieldSubmissionValue.boolValue)
            case GuardianFormFieldType.Multiselect:
                return multiselectParser(fieldSubmissionValue.stringValue)
            case GuardianFormFieldType.PhoneNumber:
                return phoneParser(fieldSubmissionValue.stringValue)
            case GuardianFormFieldType.TextArea:
            case GuardianFormFieldType.GuardianSignature:
                return ''
            default: return ''
        }
    }, [formSubmission]);

    const renderField = useCallback((field: GuardianFormField) => {
        return (
            <FormField 
                key={field.id} 
                field={field}
                isCurrentGuardianSinged={isCurrentGuardianSinged}
                isOtherGuardiansSigned={isOtherGuardiansSigned} 
                currentGuardianIsActive={currentGuardianIsActive}
                value={getValue(field)} 
                files={formSubmission ? formSubmission.files : []}
            />
        )
    }, [formSubmission, getValue]);


    

    const booleanParser = (value: boolean) => value ? 'Yes' : 'No';

    const phoneParser = (value: string | undefined) => {
        if (!value) {
            return '';
        }

        const cleanedNumber = value.replace(/\s+/g, '');

        const normalizedNumber = cleanedNumber.startsWith('+') 
            ? cleanedNumber 
            : `+${cleanedNumber}`;
        
        return parsePhoneNumberFromString(normalizedNumber).formatInternational();

    }

    const multiselectParser = (value: string | undefined) => {
        if (!value) {
            return '';
        }
        try {
            const array = JSON.parse(value) as string[];
            return array.join(', ')
        } catch(e) {
            return ''
        }
    }

    

    return (
        <>
            <GeneralInfo title={form.name} description={form.description}/>
            {form.fields.map(field => renderField(field))}
        </>
    )
}